import { useMemo } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/customTable';
import { buildUrlUsingTitleAndLocation } from 'utils';
import { formatNumber } from 'utils';

const columnsConfig = {
  rank: {
    columnName: 'Rank',
    defaultSortDirection: 'asc',
  },
  stateName: {
    columnName: 'State',
    isLink: 'comboSalaryPageIndexable',
    linkUrl: 'comboSalaryLink',
    linkTitle: 'stateColLinkTitle',
  },
  medianDisplay: {
    columnName: 'Avg. Salary',
    customSortByField: 'nationalAverageAnnualSalary',
  },
  hourlyRateDisplay: {
    columnName: 'Hourly Rate',
    customSortByField: 'nationalAverageAnnualSalary',
  },
  jobCount: {
    columnName: 'Job Count',
    isLink: 'comboJobPageIndexable',
    linkUrl: 'jobCountLink',
    customSortByField: 'jobCountFromBestState',
    linkTitle: 'jobCountColLinkTitle',
  },
};

export function SalaryByState({
  id,
  title,
  tableSet = [],
  className,
  titlePlural,
  jobsCountByTitleAndLocations,
  tableTitle = ''
}) {
  const _tableSet = useMemo(() => {
    return tableSet.map((row) => {
      const { jobCountFromBestState } = row;
      return {
        ...row,
        jobCount:
          parseInt(jobCountFromBestState ?? 0) > 0 ? formatNumber(jobCountFromBestState) : '',
        jobCountNumber: parseInt(jobCountFromBestState ?? 0),
        jobCountLink: row.comboJobPageIndexable
          ? buildUrlUsingTitleAndLocation(title, row.stateName)
          : '',
        jobCountColLinkTitle: `${title} Jobs in ${row.stateName}`,
        stateColLinkTitle: `${title} Salary in ${row.stateName}`,
      };
    });
  }, [tableSet, jobsCountByTitleAndLocations]);

  return (
    <div className={`${className || 'mt-68'} w-730`} id={id}>
      <h3 className="zp-title-h3 text-capitalize mb-4">
        {tableTitle || `Highest paying states for ${titlePlural?.toLowerCase?.()}`}
      </h3>
      <Table
        bodyData={_tableSet}
        columnConfig={columnsConfig}
        scrollOnMobile
        defaultRowsDisplay={_tableSet.length}
      />
    </div>
  );
}

SalaryByState.propTypes = {
  title: PropTypes.string.isRequired,
  tableSet: PropTypes.array.isRequired,
  id: PropTypes.string,
  customSectionTitle: PropTypes.string,
  defaultRowsDisplay: PropTypes.number,
};

SalaryByState.defaultProps = {
  id: null,
  customSectionTitle: null,
  defaultRowsDisplay: 51,
};
